<template>
  <el-upload :show-file-list="false"
             :action="action"
             :cathUrl="cathUrl"
             :on-success="onSuccess"
             :on-error="uploaderror"
             :headers="upLoadHeader"
             :before-upload="beforeUpload">
    <!--suppress JSUnresolvedVariable -->
    <a @click="chageSign()"
    >{{value}}</a>
  </el-upload>
</template>

<script>
import {nAlert, nSuccess, nWarn} from '../../../utils/notice'
import {errorHandler} from '../../../utils/errorHandler'
import md5 from 'js-md5'

export default {
  name: 'name-upload',
  props: {
    value: {
      type: String,
      default: '导入'
    },
    cathUrl: String,
    onSuccess: {
      type: Function,
      default (data) {
        const e = errorHandler('导入失败')(data)
        if (!(e instanceof Error)) {
          nSuccess('导入成功')
        }
      }
    }
  },
  data () {
    return {
      action: '',
      upLoadHeader: {}
    }
  },
  methods: {
    onExceed (files, fileList) {
      nWarn(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，
        共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    beforeUpload (file) {
      const office2003 = 'application/vnd.ms-excel'
      const office2007 =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (file.type === office2007) {
        return true
      }
      if (file.type === office2003) {
        return true
      }
      nAlert('暂不支持改格式的文件，请前往右上角帮助与支持下载对应模板')
      return false
    },
    uploaderror (err) {
      if (JSON.parse(err.message).data) {
        this.$layer.toast({
          icon: 'icon-check',
          content: JSON.parse(err.message).data,
          time: 1000
        })
      } else {
        this.$layer.toast({
          icon: 'icon-check',
          content: '导入出错',
          time: 1000
        })
      }
    },
    chageSign () {
      let timestamp = new Date().getTime()
      this.action = this.cathUrl + '&timestamp=' + timestamp
      let mainUrl = this.cathUrl
      let pUrl = mainUrl.split('/ecard')[1].split('?')[0]
      let allowToken = `url=/ecard${pUrl}&timestamp=${timestamp}&key=WLXXPBDBVDZYONRQW7P9XRTJFI1NXCKA`
      let accessToken = md5(allowToken)
      this.upLoadHeader = {
        'sign': accessToken
      }
    }
  }
}
</script>

<style scoped lang="less">
  @import "../styles/fun_var";

  .-button {
    min-width: 90px;
    .generate-common-button(#F7F7F7);
  }
  .-button:hover {
    cursor: pointer;
    color: #1362FF;
    background-color: #F7F7F7;
    border: 1px solid #1362FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/buttons/name-upload.vue